import { render } from "./ContextMenuItem.vue?vue&type=template&id=2815b472"
const script = {}

import "./ContextMenuItem.vue?vue&type=style&index=0&id=2815b472&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__